import React, { useState } from "react";
import { Button, Form, Input, Typography, Row, Col } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import {
  addDepartment,
  loadAllDepartmentPaginated,
} from "../../../redux/rtk/features/hrm/department/departmentSlice";
import toast from "react-hot-toast";

const { Title, Text } = Typography;

const AddDepartment = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    if (loading) return;
    setLoading(true);
    try {
      const resp = await dispatch(addDepartment(values));
      if (resp?.payload?.message === "success") {
        form.resetFields();
        dispatch(loadAllDepartmentPaginated({}));
      } else {
        toast.error("Failed to create department");
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="text-center mb-6 px-2">
        <Title level={3} style={{ marginBottom: 4 }}>
          Create New Department
        </Title>
        <Text type="secondary">Add a new department for your organization.</Text>
      </div>

      <Form
        form={form}
        layout="vertical"
        name="add-department"
        onFinish={handleSubmit}
        autoComplete="off"
        requiredMark={false}
        className="px-2 sm:px-6"
      >
        {/* Single field now, but using Row/Col keeps it future-proof */}
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={18} md={16}>
            <Form.Item
              label="Department Name"
              name="name"
              rules={[{ required: true, message: "Please enter a department name!" }]}
            >
              <Input placeholder="e.g. Human Resources, Marketing" size="large" />
            </Form.Item>
          </Col>
        </Row>

        {/* Submit */}
        <div className="mt-2 flex justify-start">
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={loading}
            className="w-full sm:w-auto"
          >
            <span className="flex items-center gap-2 justify-center">
              <SaveOutlined />
              Create Department
            </span>
          </Button>
        </div>
      </Form>
    </>
  );
};

export default AddDepartment;
